import { useTooltip_unstable } from "@fluentui/react-components";

import type { AppTooltipProps, AppTooltipState } from "./AppTooltip.types";
import { useConvertTooltipContent } from "../../../hooks/useConvertTooltipContent";
import { getAppTooltipStyles } from "./AppTooltip.styles";

export const useAppTooltip = (
  props: AppTooltipProps,
  visible?: boolean,
  setVisible?: (visible: boolean) => void
): AppTooltipState => {
  const { root } = getAppTooltipStyles();
  const state = useTooltip_unstable({
    ...props,
    content: {
      children: useConvertTooltipContent(props, setVisible),
      className: root,
    },
    relationship: props.relationship || "label",
    withArrow: props.withArrow || true,
    positioning: props.positioning || "below",
    onVisibleChange: (_event, data) => setVisible?.(data.visible),
    visible,
  });

  return state as AppTooltipState;
};
